/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  /**
   * Вид для отображения исправленных опечаток в поисковом запросе
   */
  app.SuggestView = app.BaseTemplatedView.extend({
    additionalOptions: ['collection'],

    /**
     * @inheritDoc
     */
    run: function (options) {
      app.BaseTemplatedView.prototype.run.apply(this, arguments);
    },

    /**
     * @inheritDoc
     */
    render: function () {
      if (this.template) {
        var data = this.model.toJSON();
        if (data.word) {
          var searchItem = _.assign({ query: this.collection.query }, data);
          this.$el.html(this.template(searchItem));
          this.$el.removeClass('hidden');
          return;
        }
        this.$el.addClass('hidden');
      }
    },
  });
})();

}.call(window));